import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as actions from '../actions/arbitrationSearch';

const initialState = fromJS({
  config: { data: [], state: null },
  codes: {
    data: {},
    state: null,
    caseState: { data: [], state: null },
    caseStatus: { data: [], state: null },
  },
  statusCodes: { data: [], state: null },
  resultsConfig: { data: [], state: null },
  results: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100, 1000, 5000, 10000],
  },
  searchLastPayload: { data: {}, state: null },
});

const arbitrationSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_SEARCH_CONFIG_SUCCESS: {
      return state
        .setIn(['config', 'state'], fetchingState.LOADED)
        .setIn(['config', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_SEARCH_CODES_SUCCESS: {
      return state
        .setIn(['codes', 'state'], fetchingState.LOADED)
        .setIn(['codes', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_SUCCESS: {
      return state
        .setIn(['resultsConfig', 'state'], fetchingState.LOADED)
        .setIn(['resultsConfig', 'data'], fromJS(action.data.results));
    }
    case actions.SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['searchLastPayload', 'data'],
          fromJS(_.get(action, 'payload', {})),
        )
        .setIn(
          ['pagination', 'count'],
          _.get(action, 'data.totalArbitrator', 0),
        );
    }
    case actions.FETCH_SEARCH_CONFIG_START: {
      return state.setIn(['config', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_CODES_START: {
      return state.setIn(['codes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_START: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.SEARCH_START: {
      return state
        .setIn(['results', 'state'], fetchingState.FETCHING)
        .setIn(['results', 'filters'], fromJS(_.get(action, 'payload', {})))
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }

    case actions.FETCH_SEARCH_CONFIG_ERROR: {
      return state.setIn(['config', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_CODES_ERROR: {
      return state.setIn(['codes', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_ERROR: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.ERROR);
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case actions.CHANGE_SORT_MODEL: {
      return state.setIn(['results', 'sortModel'], fromJS(action.payload));
    }
    case actions.CHANGE_FILTER_MODEL: {
      return state.setIn(['results', 'filterModel'], fromJS(action.payload));
    }
    case actions.FETCH_STATUS_CODES[START]: {
      return state.setIn(['statusCodes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_STATUS_CODES[SUCCESS]: {
      return state
        .setIn(['statusCodes', 'state'], fetchingState.LOADED)
        .setIn(
          ['statusCodes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_STATUS_CODES[ERROR]: {
      return state.setIn(['statusCodes', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default arbitrationSearchReducer;
